import { createSelector } from "reselect";

const selectDeviceGroupsState = (state) => state.deviceGroups;

const selectGroupsByDusn = (dusn) =>
  createSelector(selectDeviceGroupsState, (deviceGroupsState) => {
    const groups = deviceGroupsState?.groups ?? [];

    const deviceGroupsConfig = deviceGroupsState?.deviceGroupsList?.find((el) => el.dusn === dusn);
    const groupIds = deviceGroupsConfig?.groupIds ?? [];

    const deviceGroups = groups.filter((group) => groupIds.includes(group?.id));

    return deviceGroups;
  });

export { selectGroupsByDusn };
